/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import arrow1 from '../../../../../assets/c005-arrow01.png';
import arrow2 from '../../../../../assets/c005-arrow02.png';
import './component005.less';

interface IComponent005Props {
  className?: string;
  title1: string;
  title2: string;
  img1: string;
  img2: string;
  img3: string;
  content1: string;
  content2: string;
  content3: string;
  content4: string;
  content5: string;
}

const Component005: React.FunctionComponent<IComponent005Props> = ({
  title1,
  title2,
  img1,
  img2,
  img3,
  content1,
  content2,
  content3,
  content4,
  content5,
  className,
}) => {
  return (
    <>
      <div className={`component component005 ${className}`}>
        <div className="component005-container">
          <div className="left-panel panel">
            <div
              className="left-title panel-title"
              style={{ backgroundColor: '#46C87A' }}
              dangerouslySetInnerHTML={{ __html: title1 }}
            />
            <div className="left-body">
              <div
                className="left-body-content content"
                dangerouslySetInnerHTML={{ __html: content1 }}
              />
              <img className="arrow1" src={arrow1} alt="" />
              <div
                className="left-body-content content"
                dangerouslySetInnerHTML={{ __html: content2 }}
              />
            </div>
            <img
              className="left-img1 image"
              src={require(`../../../../../assets/${img1}`).default}
              alt=""
            />
            <img
              className="component005-footer-img3 image"
              src={require(`../../../../../assets/${img3}`).default}
              alt=""
            />
          </div>
          <div className="right-panel panel">
            <div
              className="right-title panel-title"
              style={{ backgroundColor: '#46C87A' }}
              dangerouslySetInnerHTML={{ __html: title2 }}
            />
            <div
              className="right-body-content content"
              dangerouslySetInnerHTML={{ __html: content3 }}
            />
            <img
              className="right-img2 image"
              src={require(`../../../../../assets/${img2}`).default}
              alt=""
            />
            <div
              className="right-body-content content"
              dangerouslySetInnerHTML={{ __html: content4 }}
            />
            <div className="right-body">
              <div
                className="right-body-content-relative content"
                dangerouslySetInnerHTML={{ __html: content5 }}
              />
              <img className="arrow2" src={arrow2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Component005;
